import { SiegADComponentsVue } from '@sieg-ad/componentes-vue';
//@ts-ignore
import '@sieg-ad/componentes-vue/styles';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(SiegADComponentsVue)
});
